module.exports = __webpack_public_path__ + "static/2025 -Global -Excellence-Banner-6a62846c5fc65f1168d17d1f50e5e0cc.png";